<template>
  <v-app class="survey-container">
    <!-- Top Banner -->
    <v-layout wrap class="no-grow">
      <v-flex xs12>
        <div class="top-gray">
          <div class="left">
            <img src="../assets/nsf-logo.png" width="319" alt="National Science Foundation. Where Discoveries Begin"/>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <!--Header -->
    <v-layout wrap class="no-grow">
      <v-flex xs12>
        <div class="blue-bar">
          <h1 class="appendYearVol">Welcome to the NSF Survey of Federal Funds for Research and Development:</h1>
        </div>
      </v-flex>
    </v-layout>

    <!-- Main Contents: Register -->
    <v-layout wrap class="page-body bg-light-blue">
      <v-flex xs4 class="flex-vert-ctr" justify-center>
        <div class="sign-in-box">
          <v-form>
            <v-layout wrap>
              <v-flex class="logo-center" xs12>
                <v-row>
                  <v-col class="py-0">
                    <img src="../assets/NSF_Logo_flat.png" alt="NSF logo" width="100px" />
                  </v-col>
                  <v-col class="py-0">
                    <h2>User Registration Form</h2>
                  </v-col>
                </v-row>
                <div v-if="error" style="color:red;">Username or E-mail or Password or Confirm-Password does not exist</div>
              </v-flex>
              <v-flex xs12>
                <v-row>
                  <v-col class="py-0">
                   <v-select
                      v-model="selectedDepartmentId"
                      :items="agencyOptions"
                      label="Select Department"
                      item-text="label"
                      item-value="value"
                      class="py-0"
                      dense></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0">
                    <v-select
                      v-model="selectedAgencyId"
                      :items="agencyOptions"
                      label="Select Agency"
                      item-text="label"
                      item-value="value"
                      class="py-0"
                      dense></v-select>
                  </v-col>
                  <v-col class="py-0">
                    <v-select
                      v-model="selectedProgramId"
                      :items="programOptions"
                      label="Select Program Office"
                      :disabled="areSearchCtrlsDisabled || programDropDownEnabled"
                      item-text="label"
                      item-value="value"
                      class="py-0"
                      dense></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0">
                    <v-select
                      v-model="selectedFieldId"
                      :items="fieldOptions"
                      label="Select Field Office"
                      :disabled="areSearchCtrlsDisabled || fieldDropDownEnabled"
                      item-text="label"
                      item-value="value"
                      class="py-0"
                      dense></v-select>
                  </v-col>
                  <v-col class="py-0">
                    <v-select
                      v-model="selectedBranchId"
                      :items="branchOptions"
                      label="Select Branch"
                      :disabled="areSearchCtrlsDisabled || branchDropDownEnabled"
                      item-text="label"
                      item-value="value"
                      class="py-0"
                      dense></v-select>
                  </v-col>
                </v-row>
                <v-row>
                    <v-col class="py-0">
                      <v-text-field  placeholder="User Name" v-model="username" required/>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field  placeholder="E-mail" v-model="email" required/>
                    </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0">
                    <v-text-field  placeholder="Password" v-model="password" required/>
                  </v-col>
                  <v-col class="py-0">
                    <v-text-field  placeholder="Confirm Password" v-model="confirmpassword" required/>
                  </v-col>
                </v-row>
                <v-layout>
                  <v-flex>
                    <v-btn normal :loading="isLoading" class="blue-button" @click="Register">Submit</v-btn>
                    <v-btn normal :loading="isLoading" class="blue-button" @click="cancel">Cancel</v-btn>
                    <v-btn class="primary" @click="onShowAllClicked" :disabled="areSearchCtrlsDisabled">Reset</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-flex>
    </v-layout>
    <Footer></Footer>
  </v-app>
</template>
<script>
import { authService } from "@/services/authService.js";
import router from "@/router";
import { footer } from "@/components/Footer.vue";
import { authTokenService } from "@/services/authTokenService.js";

export default {
  name: "register",
  data () {
    return {
      username: "",
      email: "",
      password: "",
      confirmpassword: "",
      isLoading: false,
      show: false,
      error: false
    };
  },
  methods: {
    Register () {
      this.$data.isLoading = true;
      let me = this;
      const claims = authTokenService.getClaims();
      authService
        .register(
            this.$data.username,
            this.$data.email,
            this.$data.password,
            this.$data.confirmpassword
        )
        .then(function (response) {
          me.$data.isLoading = false;
          // Redirect to home. Look at how to redirect to nextUrl?
          router.push({ name: "register" });
        })
        .catch(function (response) {
          console.log("Test handle error in component");
          me.$data.isLoading = false;
          me.$data.error = true;
          me.$data.emailed = false;
        });
    },
    cancel () {
      router.push({ name: "landing" });
    }
  }
};
</script>

<style scoped>
.center {
  text-align: center;
}
.login-container {
  border-radius: 5px;
  background-color: white;
  border: 1px solid #13314f;
}

.main-title {
  color: #313b52;
  font-family: Georgia, Times New Roman, Times, serif;
  font-size: 25px;
}
.sign-in-title-outer {
  padding-top: 60px;
}
.top-title-left-border {
  border-left: 1px solid #969696;
}
.sign-in-sub-title {
  font-family: Georgia, Time New Roman, Times, Serif;
  color: #313b52;
  font-size: 21px;
  line-height: 40px;
  font-weight: bold;
  margin: 0 0 11px 0;
}
.sign-in-sub-title-right {
  font-family: Georgia, Time New Roman, Times, Serif;
  color: #313b52;
  font-size: 40px;
  line-height: 59px;
  margin: 0 0 11px 0;
}
.content-space {
  padding: 49px 23px;
  font-family: Arial, Helvetica, san-serif;
  font-size: 1em;
  line-height: 1.8125em;
  color: #5b5853;
}
.left {
  text-align: left;
  margin-left: 2%;
}
h1 {
  margin: 10px 0 !important;
  padding: 0 !important;
  border: none !important;
  font-family: Calibri, Georgia, Time New Roman, Times, Serif;
  color: white;
  font-size: 30px;
  line-height: 40px;
  font-weight: normal;
  margin: 0 0 11px 0;
}
.contents-pane {
  margin-top: 5%;
  margin-bottom: 5%;
  margin-left: -5%;
  background-color: #f2f7fa;
  padding: 3%;
  text-align: left;
  border-style: solid;
  border-width: 0px 0px 0px 15px;
  border-color: #365f8d;
  font-size: 11pt;
  color: black;
}
.logo-center {
  margin-top: 0%;
  margin-right: 0%;
  text-align: center;
}
.log-in-fields {
  margin-bottom: -15px;
  width: 275px;
}
.log-in-fields >>> input {
  text-align: left;
}
.indent {
  margin-left: 3%;
}

.nyi {
  display: inline-block;
  margin-top: 8px;
}

</style>
